// *******************************************************************************
// Toggle Image
// *******************************************************************************

const textModules = document.querySelectorAll('.text-module');

textModules.forEach((module) => {
  const targetImages = module.querySelectorAll('.text-module__box-image');
  const targetLinks = module.querySelectorAll('.text-module__list-link[data-item]');

  const clearActiveState = () => {
    targetLinks.forEach((el) => el.classList.remove('is-active'));
    targetImages.forEach((el) => el.classList.remove('is-active'));
  };

  targetLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      if (windowWidth() <= breakpointMd) return;
      const image = module.querySelector(`[data-image="${link.dataset.item}"]`);

      clearActiveState();

      link.classList.add('is-active');
      image?.classList.add('is-active');
    });

    link.addEventListener('mouseleave', () => {
      if (windowWidth() <= breakpointMd) return;

      clearActiveState();
    });
  });
});
